export function projectStepRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_PROJECT_STEP_START":           
        case "FETCH_PROJECTS_START":                                 
        case "UPDATE_PROJECT_STEP_START":                                 
        case "DELETE_PROJECT_STEP_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_PROJECT_STEP_FULFILLED":           
        case "FETCH_PROJECTS_FULFILLED":                                 
        case "UPDATE_PROJECT_STEP_FULFILLED":                                 
        case "DELETE_PROJECT_STEP_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_PROJECT_STEP_ERROR":
        case "FETCH_PROJECTS_ERROR":
        case "UPDATE_PROJECT_STEP_ERROR":
        case "DELETE_PROJECT_STEP_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}